const computedBehavior = require('miniprogram-computed').behavior;
import {checkSendRedPacket} from './api/index';
// import Dialog from '@vant/weapp/dialog/dialog';
Component({
  behaviors: [computedBehavior],
  properties: {
    appId: {
      type: String,
      required: true,
      // value:'',
      value: "apppsu1svoj3067",
    },
    alive_id: {
      type: String,
      required: true,
      // value:'',
      value: "l_61e27342e4b0542d25ea02cd",
    },
    userId: {
      type: String,
      required: true,
      // value:'',
      value: "u_61e2736768931_qFygi5VqYB",
    },
    item:{
      type: Object,
      value: {}
    },
    isShowRedPacketItem:{
      type: Object,
      value: {}
    },
    is_red_packet_on: {
      type: Number,
      required: true,
      value: 0,
    },
    // 侧边栏icon采用的红包消息
    redPacketIcon:{
      type: Object,
      value: {}
    },
    /**
     * horizontal 横屏
     * vertical 竖屏
     */
    screenType: {
      type: String,
      value: 'vertical'
    },
    show: {
      type: Boolean,
      value: false
    }
  },
  observers: {
    'show': function (value) {
      let redPacketPop = this.data.redPacketPop;
      if (value && !redPacketPop) {
        this.showRedPacketPop();
      } else if (redPacketPop) {
        this.closePop();
      }
    }
  },
  data: {
    redPacketPop: false, // 红包弹窗的展示与隐藏
    redPacket: false, // 红包组建的隐藏与显示
    record: false, // 记录组建的隐藏与显示
    detail: false, // 记录详情组建的隐藏与显示
    isNew: true,
    red_packet_id: '', //红包id
  },
  methods: {
    beforeEnter(){
      console.log('this.data.isShowRedPacketItem.red_packet_id',this.data.isShowRedPacketItem);
      if(this.data.isShowRedPacketItem.red_packet_id){
        this.setData({
          redPacket: false,
          record: false,
          detail: true,
          red_packet_id: this.data.isShowRedPacketItem.red_packet_id
        })
      }else{
        this.setData({
          redPacket: true,
        })
      }
    },
    afterLeave(){
      this.setData({
        redPacket: false,
      })
    },
    closeRedPacket(){
      this.triggerEvent("closeRedPacket")
    },
    onParamId(e) {
      this.setData({
        redPacket: false,
        record: false,
        detail: true,
        red_packet_id: e.detail.red_packet_id
      })
    },
    showRedPacketPop() {
      let info = wx.getSystemInfoSync()
      let isIOS = info.platform === 'ios' 
      if(!this.data.is_red_packet_on && !this.data.isShowRedPacketItem.red_packet_id) {
          this.triggerEvent("closePop", {
            opened: false
          });
          if(isIOS){
              wx.showModal({
                title: 'iOS小程序暂不支持发红包',
                content: '请先联系管理员前往电脑端管理台开启红包功能。之后选用以下终端发红包：安卓小程序、微信H5或电脑端。',
                showCancel: false,
                confirmText: '好的',
                confirmColor: '#1472FF'
            })
          }else{
            wx.showModal({
              title: '红包功能暂未开启',
              content: '请联系管理员前往电脑端管理台开启。',
              showCancel: false,
              confirmText: '好的',
              confirmColor: '#1472FF'
            })
          }
          return
      }
      if (this.data.is_red_packet_on && isIOS && !this.data.isShowRedPacketItem.red_packet_id) {
        wx.showModal({
          title: 'iOS小程序暂不支持发红包',
          content: '请选用以下终端发红包：安卓小程序、微信H5或电脑端。',
          showCancel: false,
          confirmText: '好的',
          confirmColor: '#1472FF'
        })
        this.triggerEvent("closePop",{
          opened: false
        })
        return
      }
      this.setData({
        redPacketPop: true
      })
    },
    toRecord() {
      this.setData({
        redPacket: false,
        record: true,
        detail: false,
      })
    },
    toRedPacket() {
      if (this.data.record) {
        this.setData({
          redPacket: true,
          record: false,
          detail: false,
        })
      } else {
        this.setData({
          redPacket: false,
          record: true,
          detail: false,
        })
      }

    },
    // 支付完成事件
    payComplete({detail}){
      console.log("detail",detail.id);
      console.log("redPacketIcon",this.data.redPacketIcon);
      setTimeout(()=>{
        let needAfresh = true;
        this.data.redPacketIcon.list.forEach(item=>{
          if(item.id === detail.id){
            needAfresh = false
          }
        })
        // 需要重新获取红包列表
        if(needAfresh) {
          checkSendRedPacket({
            app_id: this.data.appId,
            alive_id: this.data.alive_id,
            red_packet_id: detail.id
          }).then(res=>{
            if(res.data.code === 0){
              this.triggerEvent("needAfreshRedPacketList");
            }else{
              wx.showToast({
                icon:"none",
                title:res.data.msg
              })
            }
          }).catch(()=>{
            console.log('检查失败');
          })
        }
      },5000)
      this.triggerEvent("closePop");
    },
    closePop() {
      this.triggerEvent("closePop")
      this.setData({
        redPacketPop: false,
        redPacket: true,
        record: false,
        detail: false,
      })
    },
  }
})